import { TransactionType } from '@/types/transactionRequests';
import { create } from 'zustand';

type UseOwnerSelectFormModalState = {
  open: boolean;
  type: TransactionType;
  bankAccountId: string;
  openOwnerSelectFormModal: (data: {
    type: TransactionType;
    bankAccountId: string;
  }) => void;
  closeOwnerSelectFormModal: () => void;
};

export const useOwnerSelectFormModal = create<UseOwnerSelectFormModalState>(
  set => {
    return {
      open: false,
      type: 'transfer',
      bankAccountId: '',
      openOwnerSelectFormModal: data => {
        set({
          open: true,
          type: data.type,
          bankAccountId: data.bankAccountId,
        });
      },
      closeOwnerSelectFormModal: () => {
        set({ open: false });
      },
    };
  },
);
